import React, { memo, useState, FC } from 'react';
import { Button, ButtonVariant, CmhcIcon, CmhcIconSize, ButtonSize } from '@cmhc-schl/hearth-ui';
import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';
import Helmet from 'react-helmet';
import HbtBreadcrumbComponent from 'Feature/V2/HbtBreadcrumb/components/HbtBreadcrumbComponent';
import SearchFlyout from 'Feature/V2/Shared_Portfolio/components/SearchFlyout';
import HbtPortfolioManagementSearchResultsTable from './components/HbtPortfolioManagementSearchResultsTable';

const HbtPortfolioManagementSearchResultsPage: FC = () => {
  const [openSearchFlyout, setOpenSearchFlyout] = React.useState<boolean>(false);
  const [flyoutKey, setFlyoutKey] = useState(0);
  const [prefillFromLast, setPreFillFromLast] = React.useState<boolean>(false);

  const toggleSearchDrawer = (newOpen: boolean, prefill?: boolean) => {
    setFlyoutKey((k) => k + 1);
    setOpenSearchFlyout(newOpen);
    setPreFillFromLast(prefill || false);
  };

  const { t } = useTranslation('HbtPortfolioManagementSearchResultPage');
  const stickyHeader = true;
  const thContentStyles = `${stickyHeader ? styles.frozenHeader : ''}`;

  return (
    <>
      <Helmet>
        <title>{t('Search-Results')}</title>
      </Helmet>
      <HbtBreadcrumbComponent {...t('breadcrumb', { returnObjects: true })} />
      <div className={styles.mainContent}>
        <div className={styles.layoutContainer}>
          <Stack direction="row" justifyContent="space-between" className={thContentStyles}>
            <div className={styles.headerContainer}>
              <div className={styles.header}>
                <div className={styles.title} tabIndex={0}>
                  {t('Search-Results')}
                </div>
              </div>
            </div>
            <Stack
              direction="column"
              justifyContent="space-between"
              className={styles.filterTagWrapper}
            >
              <Stack direction="row" justifyContent="flex-end" spacing={2}>
                <Button
                  type="button"
                  name="search"
                  size={ButtonSize.SMALL}
                  variant={ButtonVariant.SECONDARY}
                  leadingIcon={() => <CmhcIcon size={CmhcIconSize.SMALL} type="icon_search" />}
                  text={{
                    value: t('Portfolio-Search-Button')
                  }}
                  ariaText={{
                    value: t('Portfolio-Search-Button')
                  }}
                  onClick={() => toggleSearchDrawer(true, false)}
                  className={styles.searchButton}
                />
                <SearchFlyout
                  openSearchFlyout={openSearchFlyout}
                  toggleSearchDrawer={toggleSearchDrawer}
                  key={flyoutKey}
                  prefillFromLast={prefillFromLast}
                />
              </Stack>
            </Stack>
          </Stack>
          <HbtPortfolioManagementSearchResultsTable toggleSearchDrawer={toggleSearchDrawer} />
        </div>
      </div>
    </>
  );
};

export default memo(HbtPortfolioManagementSearchResultsPage);
